module.exports = __webpack_public_path__ + "static/media/heartbeat.a429c512.svg";